module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "radio",
      "name": "revealAtChoice"
    },
    domProps: {
      "checked": _vm.value === 'immediate'
    },
    on: {
      "click": function($event) {
        return _vm.setValueTo('immediate')
      }
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t("marker.reveal_immediate")) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "radio",
      "name": "revealAtChoice"
    },
    domProps: {
      "checked": _vm.value === 'eventstart'
    },
    on: {
      "click": function($event) {
        return _vm.setValueTo('eventstart')
      }
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t("marker.reveal_event_start")) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55ed9995"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/markerEdit/InputRevealAt.vue
// module id = 1045
// module chunks = 1